import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';

export const classes: {
    defaultProps?: ComponentsProps['MuiTablePagination'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTablePagination'];
    variants?: ComponentsVariants['MuiTablePagination'];
} = {
    styleOverrides: {
        input: {
            fontSize: 14,
        },
        toolbar: {
            paddingTop: 40,
        },
    },
};
